import { ApolloLink } from '@apollo/client';
import { authStore } from './authStore';

const authMiddleware = new ApolloLink(async (operation, forward) => {
	try {
		await authStore.refreshToken();
	} catch (error) {
		console.error('Error refreshing token:', error);
	}

	const token = authStore?.accessToken;

	operation.setContext(({ headers = {} }) => ({
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : '',
		},
	}));

	return forward(operation);
});

export default authMiddleware;
